// Global aria-live announcer (Story 2.9 AC2 + Story 2.10).
//
// Una sola región `<div aria-live="polite" class="sr-only">` montada
// al root del app (instalada por App.vue / main.js). Cualquier
// componente puede invocar `announce("message")` para que SR la lea.
//
// Debounce: si llegan múltiples announce() en < 50 ms, sobrescriben
// el último; SR no debería leer "URL copied. Selector copied." con
// 10 ms de gap (los lectores se confunden). Stragglers > 50 ms se
// emiten en orden.

import { onMounted, onUnmounted, ref } from 'vue';

const message = ref('');
let installed = false;
let debounceTimer = null;
let pendingMessage = '';

const DEBOUNCE_MS = 50;

function commit() {
  // Limpieza previa: si pintas el mismo texto dos veces, SR no
  // re-anuncia. Truqueamos con un caracter zero-width seguido del texto.
  if (message.value === pendingMessage) {
    message.value = '​' + pendingMessage;
  } else {
    message.value = pendingMessage;
  }
  debounceTimer = null;
}

export function announce(text) {
  if (typeof text !== 'string' || text.length === 0) return;
  pendingMessage = text;
  if (debounceTimer) clearTimeout(debounceTimer);
  debounceTimer = setTimeout(commit, DEBOUNCE_MS);
}

export function _flushForTests() {
  if (debounceTimer) {
    clearTimeout(debounceTimer);
    commit();
  }
}

export function _resetForTests() {
  if (debounceTimer) clearTimeout(debounceTimer);
  message.value = '';
  pendingMessage = '';
  debounceTimer = null;
}

// Composable que el AriaAnnouncer.vue (montado en App.vue) usa.
export function useAriaAnnouncer() {
  const root = ref(null);
  onMounted(() => { installed = true; });
  onUnmounted(() => { installed = false; });
  return { message, root, installed: () => installed };
}
